import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import alertTriangle from '@wetransfer/transfer/oneui/core/assets/icons/alert-triangle.svg';
import arrowDown from '@wetransfer/transfer/oneui/core/assets/icons/arrow-down.svg';
import arrowRight from '@wetransfer/transfer/oneui/core/assets/icons/arrow-right.svg';
import checkmarkBlue from '@wetransfer/transfer/oneui/core/assets/icons/checkmark--blue.svg';
import checkmarkWhite from '@wetransfer/transfer/oneui/core/assets/icons/checkmark--white.svg';
import checkmarkSimpleBlue from '@wetransfer/transfer/oneui/core/assets/icons/checkmark-simple--blue.svg';
import checkmarkSimpleWhite from '@wetransfer/transfer/oneui/core/assets/icons/checkmark-simple--white.svg';
import chevronLeft from '@wetransfer/transfer/oneui/core/assets/icons/chevron-left.svg';
import closeError from '@wetransfer/transfer/oneui/core/assets/icons/close--error.svg';
import closePrimary from '@wetransfer/transfer/oneui/core/assets/icons/close--primary.svg';
import closeWhiteCircle from '@wetransfer/transfer/oneui/core/assets/icons/close--white-circle.svg';
import close from '@wetransfer/transfer/oneui/core/assets/icons/close.svg';
import externalLink from '@wetransfer/transfer/oneui/core/assets/icons/external-link.svg';
import info from '@wetransfer/transfer/oneui/core/assets/icons/info.svg';
import link from '@wetransfer/transfer/oneui/core/assets/icons/link.svg';
import loadingDotsWhite from '@wetransfer/transfer/oneui/core/assets/icons/loading-dots--white.svg';
import lock from '@wetransfer/transfer/oneui/core/assets/icons/lock.svg';
import mail from '@wetransfer/transfer/oneui/core/assets/icons/mail.svg';
import more from '@wetransfer/transfer/oneui/core/assets/icons/more.svg';
import pencil from '@wetransfer/transfer/oneui/core/assets/icons/pencil.svg';
import pin from '@wetransfer/transfer/oneui/core/assets/icons/pin.svg';
import plus from '@wetransfer/transfer/oneui/core/assets/icons/plus.svg';
import questionMarkCircle from '@wetransfer/transfer/oneui/core/assets/icons/question-mark-circle.svg';
import warningWhite from '@wetransfer/transfer/oneui/core/assets/icons/warning--white.svg';

import styles from './Icon.module.scss';

export type IconName =
  | 'add-user'
  | 'arrow-down'
  | 'arrow-right'
  | 'checkmark--blue'
  | 'checkmark-simple--blue'
  | 'checkmark--white'
  | 'checkmark-simple--white'
  | 'chevron-left'
  | 'close'
  | 'close--primary'
  | 'close--error'
  | 'close--white-circle'
  | 'external-link'
  | 'info'
  | 'link'
  | 'loading-dots--white'
  | 'lock'
  | 'mail'
  | 'more'
  | 'pencil'
  | 'plus'
  | 'warning--white'
  | 'alert-triangle'
  | 'question-mark-circle'
  | 'pin';

export interface IconProps {
  name: IconName;
  alt?: string;
  size?: number;
  className?: string;
}

interface IconMapProps {
  [key: string]: string;
}

const IconMap: IconMapProps = {
  'arrow-down': arrowDown,
  'arrow-right': arrowRight,
  'checkmark--blue': checkmarkBlue,
  'checkmark-simple--blue': checkmarkSimpleBlue,
  'checkmark--white': checkmarkWhite,
  'checkmark-simple--white': checkmarkSimpleWhite,
  'chevron-left': chevronLeft,
  close: close,
  'close--white-circle': closeWhiteCircle,
  'close--primary': closePrimary,
  'close--error': closeError,
  'external-link': externalLink,
  info: info,
  link: link,
  'loading-dots--white': loadingDotsWhite,
  lock: lock,
  mail: mail,
  more: more,
  pencil: pencil,
  plus: plus,
  'warning--white': warningWhite,
  'alert-triangle': alertTriangle,
  'question-mark-circle': questionMarkCircle,
  pin: pin,
};

const Icon: FC<IconProps> = ({ name, alt, size = 30, className }) => {
  const imgStyle = useMemo(() => ({ width: size, height: size }), [size]);

  return (
    <span className={classNames(styles.container, className)}>
      <img
        src={IconMap[name]}
        alt={alt ? alt : `${name} icon`}
        className={styles.icon}
        style={imgStyle}
        data-testid={'OneUI-Icon'}
      />
    </span>
  );
};

export default Icon;
